import React, { useEffect, useRef } from 'react';
import { ContainerSemaphore, TitleSemaphore, ContainerCard } from './styles';
import { Props } from './types';
import CardDesktop from './Card';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useWindowSize } from '../../../../../hook/useWindowSize';
import { loadRequest } from '../../../../../store/ducks/semaphore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';

const Semaphore: React.FC<Props> = () => {
  const { width }: any = useWindowSize();
  const cardContainerRef = useRef<any>();
  const dispatch = useDispatch();

  const cdAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo?.codCdd);
  const inscricoesAtivas = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const urgente = useSelector((state: ApplicationState) => state.Semaphore?.data[0]?.urgente);
  const alta = useSelector((state: ApplicationState) => state.Semaphore?.data[0]?.alta);
  const media = useSelector((state: ApplicationState) => state.Semaphore?.data[0]?.media);
  const baixa = useSelector((state: ApplicationState) => state.Semaphore?.data[0]?.baixa);
  const [handleIcon, setHandleIcon] = React.useState<JSX.Element>(<DownOutlined />);

  useEffect(() => {
    dispatch(loadRequest(cdAtivo as number, inscricoesAtivas));
  }, [cdAtivo, inscricoesAtivas, dispatch]);

  const handleClick = (): void => {
    if (cardContainerRef.current?.style.display === 'grid') {
      cardContainerRef.current.style.display = 'none';
      setHandleIcon(<DownOutlined />);
    } else {
      cardContainerRef.current.style.display = 'grid';
      setHandleIcon(<UpOutlined />);
    }
  };

  return (
    <ContainerSemaphore className="themeSLA">
      <TitleSemaphore>
        Atendimentos com SLA à vencer{' '}
        <span onClick={() => handleClick()} data-testid="arrow">
          {width <= 425 && handleIcon}
        </span>
      </TitleSemaphore>

      <ContainerCard ref={cardContainerRef} data-testid="semaphore">
        <span data-testid="listitem">
          <CardDesktop
            key="Urgente"
            color="#F5222D"
            title="Urgente"
            info="Atendimentos com SLA de 3 horas, sendo o primeiro atendimento em até 40 minutos "
            quantity={urgente?.total}
            protocolo={urgente?.protocolos?.reduce((init: number[], current) => {
              if (!init.includes(current)) {
                init.push(current);
              }
              return init;
            }, [])}
          />
        </span>

        <span data-testid="listitem">
          <CardDesktop
            key="Alta"
            color="#FA8C16"
            title="Alta"
            info="Atendimentos com SLA de 5 horas, sendo o primeiro atendimento em até 1 hora e 30 minutos"
            quantity={alta?.total}
            data-testid="listitem"
            protocolo={alta?.protocolos?.reduce((init: number[], current) => {
              if (!init.includes(current)) {
                init.push(current);
              }
              return init;
            }, [])}
          />
        </span>

        <span data-testid="listitem">
          <CardDesktop
            key="Media"
            color="#52C41A"
            title="Média"
            info="Atendimentos com SLA de 6 horas, sendo o primeiro atendimento em até 3 horas"
            quantity={media?.total}
            data-testid="listitem"
            protocolo={media?.protocolos?.reduce((init: number[], current) => {
              if (!init.includes(current)) {
                init.push(current);
              }
              return init;
            }, [])}
          />
        </span>

        <span data-testid="listitem">
          <CardDesktop
            key="Baixa"
            color="#939195"
            title="Baixa"
            info="Atendimentos com SLA de 8 horas, sendo o primeiro atendimento em até 5 horas"
            quantity={baixa?.total}
            data-testid="listitem"
            protocolo={baixa?.protocolos?.reduce((init: number[], current) => {
              if (!init.includes(current)) {
                init.push(current);
              }
              return init;
            }, [])}
          />
        </span>
      </ContainerCard>
    </ContainerSemaphore>
  );
};

export default Semaphore;
